import { Controller } from "@hotwired/stimulus"

// Opens a native <dialog> as a modal. Escape, focus trapping and the backdrop are the
// element's own job - all this adds is the open click and a close that a button can call.
//
// The dialog stays in the markup it belongs to (a calendar day owns its own confirm/release
// panel), so a Turbo Stream that replaces that markup takes the dialog with it: removing a
// top-layer element closes it, which is exactly the wanted behaviour after the action lands.
export default class extends Controller {
  static targets = ["dialog"];

  open() {
    this.dialogTarget.showModal();
  }

  close() {
    this.dialogTarget.close();
  }

  // ::backdrop is not a child, so a click on it reports the dialog itself as the target -
  // that is the only way to tell "outside" from "on the panel".
  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close();
  }
}
